import React from "react";

const HomeContainer = () => {
  return (
    <>
      <div className="flex flex-col gap-5 w-[694px] px-2">
        <img src="https://rios.ac.in/images/image3.png" alt="CSSE" />
        <div className="flex flex-col gap-4">
          <h1 className="text-[28px] font-semibold border-b-[1px] border-gray-400">
            Welcome to Council for Secondary and Senior Secondary Education
          </h1>
          <p className="text-[15px] font-medium">
            Secondary education is the stage of education following primary
            education. Except in countries where only primary or basic education
            is compulsory, secondary education includes the final stage of
            compulsory education and in many countries it is entirely
            compulsory. Secondary education is characterised by transition from
            primary education to tertiary, post - secondary or higher education.
            Higher Secondary Examination is a centralised examination of class
            12. All the educational boards being autonomous bodies, their
            sessions of conducting exams differ from each other. The number of
            subjects, type of exams and grading methods differ among the boards.
            Clearing Higher Secondary Examination is mandatory for pursuing
            higher education or under graduate studies in India. Earlier, the
            only mode of regular education used to deprive the working class,
            professionals, businessmen, house wives, students of weaker section
            of the society and the school dropout candidates. As per the data it
            is evident that a major section of our society does not enter the
            higher education because these students have to be the breadwinners
            for their families. There is high level of awareness and desire
            among the mass to improve the standards and level of higher
            education. There has been a considerable increase in the spread of
            educational institutes during the period 1950-51 and 2007-2008.
            During these periods scope for secondary and higher secondary
            education increased by 3 times. Thus, it has given rise to a
            particular segment of so called Private Candidates. A private
            candidate is someone who is not in full time education in a school,
            college or similar educational institution. A private candidate can
            be a part time student, someone studying evening courses, school
            dropout, someone taking a correspondence or distance learning course
            or someone who is being home schooled or self taught. Here Delhi
            Board of Senior Secondary Education plays a vital role in balancing
            the equation of getting those special students in a common platform
            , where they can avail low cost optimum & substantial education,
            learn the basics , examine & certify and appear for their first
            benchmark of Examination and obtain certificate of secondary level.
            It is just an initiative in pursuance to our national educational
            drive to help, encourage and support the neo-literates. India's
            improved education system is often cited as one of the main
            contributors to the economic rise of India. However, India continues
            to face stern challenges. Despite growing investment in education,
            25% of its population is still illiterate;only 15% of the students
            reach high school, and just 7% graduate. The situation at senior/
            higher secondary education is still disheartening. The quality of
            education is significantly poor as compared with major developing
            nations. It is also not possible for the government alone to create
            infrastructure for the growing number of students at secondary and
            senior secondary level. With a mission to provide relevant
            continuing education at school stage, up to pre-degree it is,
            therefore, important to open school with public-private partnership.
            The organization has been carrying out some research work also over
            the last 3-4 years. With the aim and objective of enhancing and
            accelerating the enrolment/ retention at secondary and senior/
            secondary level,  Council for secondary and senior secondary
            Education (CSSE) was conceived and has been set up as an autonomous
            registered body under the Societies Registration Act.
          </p>
        </div>
      </div>
    </>
  );
};

export default HomeContainer;
